let gameData = [];

gameData = [
    {
        title: "Fruitchet",
        description: "Art by Ijeamaka Anyene. See fruit designs generated with code!",
        link: "https://ijeamaka.art/portfolio/fruitchet/"
    },
    {
        title: "Aleksandra Jovanic",
        description: "Find beautiful skies, leaves, and abstract art all generated by computers!",
        link: "http://aleksandrajovanic.com/"
    },
    {
        title: "Buena Vida Art",
        description: "Art by Jimena Buena Vida. See beautiful, brightly colored abstract generative art!",
        link: "https://www.buenavidaart.com/"
    },
    {
        title: "Mutart",
        description: "See strange and beautiful landscapes and interesting, colorful abstract art.",
        link: "https://www.fxhash.xyz/u/Mutart"
    },
    {
        title: "kira0",
        description: "See generative art reflecting on urban and natural landscapes created by kira0.",
        link: "https://www.fxhash.xyz/u/kira0"
    },
    {
        title: "CSS Patterns",
        description: "CSS Patterns that can be copied for use in your own website! Learn how to turn your website into a fascinating art piece!",
        link: "https://css-pattern.com/"
    },
    {
        title: "3DManatee",
        description: "See colorful abstract art created by 3DManatee!",
        link: "https://www.fxhash.xyz/u/3DManatee"
    },
    ]


export default gameData;
